import classNames from 'classnames'
import React from 'react'

const Logout: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="26" fill="none" viewBox="0 0 22 26">
		<path
			className={classNames('fill-brand-primary-md')}
			d="M15.889 19.25V15.5H7.333v-5h8.556V6.75L22 13l-6.111 6.25zM13.444.5c.649 0 1.27.263 1.729.732A2.53 2.53 0 0115.889 3v2.5h-2.445V3h-11v20h11v-2.5h2.445V23a2.53 2.53 0 01-.716 1.768 2.417 2.417 0 01-1.729.732h-11c-.648 0-1.27-.263-1.728-.732A2.53 2.53 0 010 23V3c0-.663.258-1.299.716-1.768A2.417 2.417 0 012.444.5h11z"
		/>
	</svg>
)

export default Logout
